import React from 'react';

function DevPanel({
  isOpen,
  onClose,
  authUser,
  buddy,
  onSetLevel,
  onSetStage,
  onSetAnimal,
  onSetEggColor,
  onSetHappiness,
  onAddXP,
  onResetFirstTimeSelection,
  onShowAnimalSelector,
  onShowEggSelector,
}) {
  if (!isOpen) return null;

  return (
    <div className="dev-panel-overlay" onClick={onClose}>
      <div className="dev-panel" onClick={(event) => event.stopPropagation()}>
        <div className="dev-panel-header">
          <div>
            <h3>DEV Mode</h3>
            {authUser?.email && <p className="settings-note">Account: {authUser.email}</p>}
          </div>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="dev-section">
          <h4>Buddy Controls</h4>
          <div className="dev-control-group">
            <label>Set Level</label>
            <div className="dev-button-grid">
              {[1, 5, 10, 20, 35, 50].map((level) => (
                <button key={level} type="button" onClick={() => onSetLevel(level)}>
                  L{level}
                </button>
              ))}
            </div>
          </div>
          <div className="dev-control-group">
            <label>Set Stage</label>
            <div className="dev-button-grid">
              {['egg', 'hatchling', 'young', 'adult', 'elder', 'legendary'].map((stage) => (
                <button key={stage} type="button" onClick={() => onSetStage(stage)}>
                  {stage}
                </button>
              ))}
            </div>
          </div>
          <div className="dev-control-group">
            <label>Animal</label>
            <select
              value={`${buddy.animalType}|${buddy.rarity}`}
              onChange={(event) => {
                const [animalType, rarity] = event.target.value.split('|');
                onSetAnimal(animalType, rarity);
              }}
            >
              <optgroup label="Selectable (Common)">
                {['bird', 'dinosaur', 'penguin', 'bear', 'cat', 'dog', 'horse'].map((animal) => (
                  <option key={animal} value={`${animal}|common`}>
                    {animal.charAt(0).toUpperCase() + animal.slice(1)}
                  </option>
                ))}
              </optgroup>
              <optgroup label="Grey Egg (Common)">
                {['rabbit', 'turtle', 'frog'].map((animal) => (
                  <option key={animal} value={`${animal}|common`}>
                    {animal.charAt(0).toUpperCase() + animal.slice(1)}
                  </option>
                ))}
              </optgroup>
              <optgroup label="Neon Egg (Rare)">
                {['phoenix', 'spaceOwl', 'crystalFox'].map((animal) => (
                  <option key={animal} value={`${animal}|rare`}>
                    {animal === 'spaceOwl'
                      ? 'Space Owl'
                      : animal === 'crystalFox'
                        ? 'Crystal Fox'
                        : animal.charAt(0).toUpperCase() + animal.slice(1)}
                  </option>
                ))}
              </optgroup>
              <optgroup label="Alien Egg (Mythical)">
                {['alien', 'eldritchEntity', 'timeDragon'].map((animal) => (
                  <option key={animal} value={`${animal}|mythical`}>
                    {animal === 'eldritchEntity'
                      ? 'Eldritch Entity'
                      : animal === 'timeDragon'
                        ? 'Time Dragon'
                        : animal.charAt(0).toUpperCase() + animal.slice(1)}
                  </option>
                ))}
              </optgroup>
            </select>
          </div>
          <div className="dev-control-group">
            <label>Egg Color</label>
            <select value={buddy.eggColor} onChange={(event) => onSetEggColor(event.target.value)}>
              <optgroup label="Selectable Colors">
                {['blue', 'red', 'green', 'yellow', 'purple', 'orange', 'brown', 'black', 'white', 'pink'].map((color) => (
                  <option key={color} value={color}>
                    {color.charAt(0).toUpperCase() + color.slice(1)}
                  </option>
                ))}
              </optgroup>
              <optgroup label="RNG-Only Colors">
                {['grey', 'neon', 'alien'].map((color) => (
                  <option key={color} value={color}>
                    {color.charAt(0).toUpperCase() + color.slice(1)}
                  </option>
                ))}
              </optgroup>
            </select>
          </div>
          <div className="dev-control-group">
            <label>Set Mood (Happiness)</label>
            <div className="dev-button-grid">
              {[
                { label: 'Happy', value: 100 },
                { label: 'Neutral', value: 60 },
                { label: 'Sad', value: 30 },
                { label: 'Unhappy', value: 10 },
              ].map((preset) => (
                <button key={preset.label} type="button" onClick={() => onSetHappiness(preset.value)}>
                  {preset.label}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="dev-section">
          <h4>User Controls</h4>
          <div className="dev-control-group">
            <label>Add XP</label>
            <div className="dev-button-grid">
              {[100, 500, 1000, 5000].map((amount) => (
                <button key={amount} type="button" onClick={() => onAddXP(amount)}>
                  +{amount} XP
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="dev-section">
          <h4>Flow Controls</h4>
          <div className="dev-control-group">
            <button type="button" onClick={onResetFirstTimeSelection}>Reset First-Time Selection</button>
            <button type="button" onClick={onShowAnimalSelector}>Show Animal Selector</button>
            <button type="button" onClick={onShowEggSelector}>Show Egg Color Selector</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DevPanel;
